import { CurrencyNumberFormatOptions } from "@intlify/core-base";
import { AllowedLocales } from "~/types/i18n/AllowedLocales";
import { AllowedStores } from "~/types/i18n/AllowedStores";

export enum SearchProvider {
  klevu = "klevu",
  magento = "magento",
}

export interface StoreConfigCurrency
  extends Partial<CurrencyNumberFormatOptions> {
  currency: string;
  decimal: string;
  symbol?: string;
}

export interface StoreConfig {
  code: AllowedStores;
  locales: AllowedLocales[];
  domain: string;
  priceFormat?: StoreConfigCurrency;
  /**
   * Override translation files per locale for this store.
   * When set, the specified file will be merged on top of the default locale file.
   * Example: { [AllowedLocales.en]: "en-za.json" }
   */
  localeFiles?: Partial<Record<AllowedLocales, string>>;
  /**
   * Search provider for this store.
   * Defaults to 'klevu' if not specified.
   */
  searchProvider?: SearchProvider;
}
